module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_37.030dede2.png";